import React, { FC, ReactElement } from 'react';
import { Helmet } from 'react-helmet';
import { Maybe } from '../../gatsby-types';

type Props = Readonly<{
  title: Maybe<string>;
}>;

export const Header: FC<Props> = ({ title }): ReactElement => {
  return (
    <div className='application'>
      <Helmet>
        <title>{title}</title>
        <meta charSet='utf-8'/>
        <meta httpEquiv='x-ua-compatible' content='ie=edge'/>
        <meta name='viewport' content='width=device-width, initial-scale=1, shrink-to-fit=no'/>
        <meta name='note' content='environment=development'/>
        <link href='https://fonts.googleapis.com/icon?family=Material+Icons' rel='stylesheet'/>
      </Helmet>
    </div>
  );
};
